/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['http', '../utils', 'security', 'endpoints', './batchSearch',
    './searchTypeConfigurationFactory', './requestParamsFactory', 'lodash/core'],
function(http, utils, security, endpoints, batchSearch, createSearchTypeConfiguration, createRequestParams, _) {
    'use strict';

    var queryParamsNames = [
        'typeahead', 'limit', 'ofs', 'countrySet', 'lat', 'lon', 'language',
        'radius', 'topLeft', 'btmRight', 'idxSet', 'minFuzzyLevel', 'maxFuzzyLevel',
        'geometryList', 'extendedPostalCodesFor', 'maxDetourTime', 'view'
    ];

    return {
        search: function(options, callback) {
            var searchTypeConfiguration = createSearchTypeConfiguration();
            var requestParams = createRequestParams(queryParamsNames, searchTypeConfiguration, options);
            var pathParams = requestParams.pathParams;
            var queryParams = requestParams.queryParams;
            var httpParams;

            // if an API key is specified, include it
            // an API key can be omitted if an API proxy is being used
            queryParams.key = utils.or(options.key, security.getKey('services/search'));

            httpParams = {
                url: '{protocol}://' + endpoints.search,
                pathParameters: pathParams,
                queryParameters: queryParams,
                callback: callback,
                callbackParam: 'callback',
                fail: options.fail
            };

            if (_.isEmpty(requestParams.postParams)) {
                http.get(httpParams);
            } else {
                httpParams.bodyParameters = requestParams.postParams;
                http.post(httpParams);
            }
        },
        batch: batchSearch(queryParamsNames)
    };
});



// WEBPACK FOOTER //
// ./rest/search/search.js